<template>
  <div>
    <div v-if="false">
      <j-assignment-form-update
        ref="employeeForm"
        mode="update"
        @data="getData"/>
    </div>

    <b-row v-show="false">
      <b-col
        sm="12"
        md="9">
        <div class="float-right m__t--20">
          <b-button
            class="btn red"
            @click="openModalConfirm('delete')">Delete</b-button>
          <b-button
            class="btn blue"
            @click="openModalConfirm('employment')">Update</b-button>
        </div>
      </b-col>
      <b-col
        sm="12"
        md="3"/>
    </b-row>

    <b-row>
      <b-col
        sm="12"
        md="9">
        <j-title-header
          v-show="false"
          :options="titlePosition"/>
        <b-form-group :class="{'error-input' : $v.data_position.position.$error}">
          <label> Position </label>
          <j-single-select
            v-if="defaultOptions.length > 0"
            v-model="$v.data_position.position.$model"
            :is-async="true"
            :cache-option="false"
            :load-options="loadOptionsPosition"
            :default-options="defaultOptions"
            placeholder="Ex: CTO"
            value-format="object"
            label="name" />
        </b-form-group>
        <b-button
          class="btn blue"
          @click="openModalConfirm('position')">
          {{ labelBtnPosition }}
        </b-button>
      </b-col>

      <b-col
        sm="12"
        md="3"/>
    </b-row>

    <b-modal
      ref="modalConfirm"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <j-title-header :options="title"/>
      <div>
        <j-modal-confirm-with-reason
          v-if="isOpen"
          :mode="submitMode"
          :employee-data="employee_data"
          :position-data="data_position"
          @update-form="continueUpdate"
          @close-modal="closeModalConfirm"/>
      </div>
    </b-modal>
    <br>
  </div>
</template>

<script>
/* eslint-disable max-len */
// eslint-disable-next-line import/no-extraneous-dependencies
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import jAssignmentFormUpdate from '@/views/user-employee/assignment/jAssignmentFormUpdate';
import jModalConfirmWithReason from './jModalConfirmWithReason';

export default {
  components: {
    jAssignmentFormUpdate,
    jModalConfirmWithReason,
  },
  validations() {
    return {
      data_position: {
        position: {
          required,
        },
      },
    };
  },
  data() {
    return {
      defaultOptions: [],
      employee_data: null,
      titlePosition: {
        icon: 'fa-user',
        main_title: 'Position',
        opt_title: '',
      },
      title: {
        main_title: 'CONFIRMATION',
      },
      data_position: {
        id: 0,
        position: null,
        parent_position: '',
        division: [],
      },
      data_positions: [],
      temp_position: null,
      labelAddPosition: 'Add Position',
      labelBtnPosition: 'Update',
      firstLoad: true,
      submitMode: 'employment',
      isOpen: false,
    };
  },
  computed: {
    ...mapState('jStoreEmployee', ['organigram_detail', 'list_bank']),

    generateData() {
      const dataRoles = [];
      this.employee_data.role.forEach((val) => {
        dataRoles.push(val.id);
      });
      const dataSecMapp = [];
      this.employee_data.secretary_mode_mapping.forEach((val) => {
        dataSecMapp.push(val.id);
      });
      const genData = {
        id: this.employee_data.id,
        email: this.employee_data.email,
        employee_id: this.employee_data.employee_id,
        personal_email: this.employee_data.personal_email,
        password: this.employee_data.password ? this.employee_data.password : '',
        first_name: this.employee_data.first_name,
        last_name: this.employee_data.last_name ? this.employee_data.last_name : '',
        group_id: this.employee_data.teams ? this.employee_data.teams.id : 0,
        roles: dataRoles,
        code: this.employee_data.code,
        join_date: this.employee_data.join_date,
        resign_date: this.employee_data.end_date,
        photo_url: this.employee_data.photo,
        phone_number: this.employee_data.phone_number,
        date_of_birth: this.employee_data.date_of_birth,
        place_of_birth: this.employee_data.place_of_birth,
        bank_account_name: this.employee_data.bank_name ? this.employee_data.bank_name.name : '',
        bank_account_number: this.employee_data.bank_account_number,
        bank_account_owner: this.employee_data.bank_account_holder_name,
        bank_account_branch: this.employee_data.bank_account_branch,
        contract_type: this.employee_data.employment_type ? this.employee_data.employment_type : '',
        type_of_contract: this.employee_data.contract_type ? this.employee_data.contract_type : '',
        active_reason: this.employee_data.active_reason ? this.employee_data.active_reason : '',
        non_active_reason: this.employee_data.nonactive_reason ? this.employee_data.nonactive_reason : '',
        secretary_mode: this.employee_data.secretary_mode,
        secretary_mode_list_team: dataSecMapp,
        country_id: this.employee_data.country ? this.employee_data.country.id : 0,
        employee_status: this.employee_data.employee_status ? this.employee_data.employee_status.id : 0,
        other_name: this.employee_data.other_name,
        gender: this.employee_data.gender,
        nationality_type: this.employee_data.nationality_type ? this.employee_data.nationality_type : null,
        identity_type: this.employee_data.id_type ? this.employee_data.id_type.text : '',
        passport_expired_date: this.employee_data.exp_date ? this.employee_data.exp_date : '',
        identity_no: this.employee_data.id_number,
        fax_number: 0,
        religion: this.employee_data.religion,
        marital_status: this.employee_data.marital_status,
        home_address: this.employee_data.home_address,
        postal_code: this.employee_data.postal_code,
        about: this.employee_data.notes,
        title: '',
        tax_identification_number: 0,
        bpjs_ketenagakerjaan: '',
        bpjs_kesehatan: '',
        ptkp: '',
        max_disbursed_count: 0,
        province_id: this.employee_data.province ? this.employee_data.province : '',
        city_id: this.employee_data.city ? this.employee_data.city : '',
        office_country_id: this.employee_data.office_country ? this.employee_data.office_country : '',
        office_province_id: this.employee_data.office_province ? this.employee_data.office_province : '',
        office_city_id: this.employee_data.office_city ? this.employee_data.office_city : '',
        contract_start_date: this.$moment(this.employee_data.contract_start_date).format('YYYY-MM-DD'),
        contract_end_date: this.$moment(this.employee_data.contract_end_date).format('YYYY-MM-DD'),
        location_id: this.employee_data.company_location ? this.employee_data.company_location : '',
        address: this.employee_data.address ? this.employee_data.address : '',
        office_address: this.employee_data.office_address ? this.employee_data.office_address : '',
        address_2: '',
        address_3: '',
        post_code: '',
        iban: '',
        managers: [],
        salutation: '',
        passport_no: '',
        passport_issuing: '',
        passport_issuing_date: '',
        passport_nationality: '',
        employment_type_id: this.employee_data.employment_type_id ? this.employee_data.employment_type_id : 0,
        employment_subtype_id: this.employee_data.employment_subtype_id ? this.employee_data.employment_subtype_id : 0,
      };
      return genData;
    },
  },
  watch: {
    organigram_detail(newVal) {
      if (newVal.length > 0 && this.firstLoad) {
        this.data_position.position = {
          id: newVal[0].organigram.id,
          label: newVal[0].organigram.name,
          text: newVal[0].organigram.name,
          position_name: newVal[0].organigram.name,
          position_code: newVal[0].organigram.code,
          description: newVal[0].organigram.description,
          divisions: newVal[0].organigram.divisions || [],
          fulldata: newVal[0].organigram,
        };

        this.temp_position = {
          id: newVal[0].organigram.id,
          name: newVal[0].organigram.name,
          code: newVal[0].organigram.code,
          description: newVal[0].organigram.description,
          user_company_id: this.$route.params.id,
          organigram_head_id: newVal[0].organigram.organigram_head_id,
          organigram_head_name: newVal[0].organigram.organigram_head_name,
          divisions: newVal[0].organigram.divisions || [],
        };

        this.labelAddPosition = 'Update Position';
        this.labelBtnPosition = 'Update';
      }
    },
    // eslint-disable-next-line
    'data_position.position': function (newData) {
      this.data_position.parent_position = '';
      this.data_position.division = [];
      if (newData.organigram_head_id !== 0) {
        this.data_position.parent_position = newData.organigram_head_name;
      }

      if (newData.divisions.length > 0) {
        const dataDivisions = newData.divisions;
        dataDivisions.forEach((val, index) => {
          dataDivisions[index].label = val.name;
        });
        this.data_position.division = dataDivisions;
      }
    },
  },
  created() {
    const employeeId = {
      id: Number(this.$route.params.id),
    };

    this.getListPositionDefault().then((data) => { this.defaultOptions = data; });
    this.detailEmployee(employeeId);
  },
  methods: {
    ...mapActions('jStoreEmployee', ['updateEmployee', 'detailEmployee', 'updateOrganigram', 'getListPositionDefault']),

    getData(data) {
      this.employee_data = data;
    },
    closeModalConfirm() {
      this.$refs.modalConfirm.hide();
      this.isOpen = false;
    },
    openModalConfirm(data) {
      this.submitMode = data;

      if (this.submitMode === 'position') {
        // this.$refs.employeeForm.save();
        // if (this.employee_data !== null) {
        //   this.isOpen = true;
        this.$v.data_position.$touch();
        if (!this.$v.data_position.$error) {
          // this.isOpen = true;
          // this.$refs.modalConfirm.show();
          this.updatePosition();
        }
        // }
      } else if (this.submitMode === 'employment' || this.submitMode === 'delete') {
        this.$refs.employeeForm.save();
        if (this.employee_data !== null) {
          this.isOpen = true;
          this.$refs.modalConfirm.show();
        }
      }
    },
    continueUpdate(data) {
      if (data) {
        if (this.submitMode === 'position') {
          this.updatePosition();
        } else if (this.submitMode === 'employment') {
          this.updateEmployee(this.generateData);
        } else {
          const eraseData = this.generateData;
          eraseData.code = null;
          eraseData.join_date = null;
          eraseData.end_date = null;
          eraseData.contract_type = null;
          eraseData.contract_time_remaining = null;
          eraseData.contract_start_date = null;
          eraseData.contract_end_date = null;
          eraseData.employee_status = null;
          eraseData.active_reason = null;
          eraseData.nonactive_reason = null;
          eraseData.teams = null;
          eraseData.office_country = null;
          eraseData.office_province = null;
          eraseData.office_city = null;
          eraseData.office_address = null;
          eraseData.company_location = null;
          eraseData.employment_type = null;
          eraseData.employment_type_id = null;
          eraseData.employment_subtype_id = null;
          this.updateEmployee(eraseData);
        }
      }
    },
    loadOptionsPosition({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.$store.dispatch('jStoreEmployee/getListPosition', { reqData, callback, label: (this.filter ? this.filter : 'name') });
      }
    },
    updatePosition() {
      const dataDivisions = [];
      this.data_position.division.forEach((val) => {
        dataDivisions.push(val.id);
      });

      const data = {
        id: this.data_position.position.id,
        name: this.data_position.position.name,
        code: this.data_position.position.code,
        description: this.data_position.position.description,
        user_company_id: this.$route.params.id,
        organigram_head_id: this.data_position.position.organigram_head_id,
        organigram_head_name: this.data_position.position.organigram_head_name,
        divisions: dataDivisions,
      };
      const generateData = {
        payload: data,
        user_company_id: this.$route.params.id,
      };
      this.updateOrganigram(generateData);

      if (this.labelAddPosition === 'Update Position') {
        const dataDeleteDivisions = [];
        this.temp_position.divisions.forEach((val) => {
          dataDeleteDivisions.push(val.id);
        });
        const dataDelete = {
          id: this.temp_position.id,
          name: this.temp_position.name,
          code: this.temp_position.code,
          description: this.temp_position.description,
          user_company_id: 0,
          organigram_head_id: this.temp_position.organigram_head_id,
          organigram_head_name: this.temp_position.organigram_head_name,
          divisions: dataDeleteDivisions,
        };

        const generateDataDelete = {
          payload: dataDelete,
          user_company_id: this.$route.params.id,
        };
        this.updateOrganigram(generateDataDelete);
      }

      this.labelAddPosition = 'Update Position';
      this.firstLoad = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-employee/assignment/jAssignment.vue